<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    {{ 'common.search' | transloco }}
                </div>
                <div class="card-body">
                    <ng-container>
                        <div class="row">
                            <div class="col-6 col-md-2">
                                <button (click)="predicate.mode = '自社落札済'; showItems()" type="button" class="btn btn-block btn-primary">{{ 'user.won_by_us' | transloco }}</button>
                            </div>
                            <div class="col-6 col-md-2">
                                <button (click)="predicate.mode = '自社落札中'; showItems()" type="button" class="btn btn-block btn-primary">{{ 'user.bidding_by_us' | transloco }}</button>
                            </div>
                            <div class="col-6 col-md-2">
                                <button (click)="predicate.mode = '落札可能'; showItems()" type="button" class="btn btn-block btn-primary">{{ 'user.open_for_bidding' | transloco }}</button>
                            </div>
                            <div class="col-6 col-md-2">
                                <button (click)="predicate.mode = '終了済'; showItems()" type="button" class="btn btn-block btn-primary">{{ 'user.ended' | transloco }}</button>
                            </div>
                            <div class="col-6 col-md-2" *ngIf="view != 'custom'">
                                <button (click)="view = 'custom'; showItems()" type="button" class="btn btn-block btn-primary">{{ 'user.show_conditions' | transloco }}</button>
                            </div>
                            <div class="col-6 col-md-2" *ngIf="view == 'custom'">
                                <button (click)="view = 'easy'; showItems()" type="button" class="btn btn-block btn-primary">{{ 'user.hide_conditions' | transloco }}</button>
                            </div>
                            <div class="col-6 col-md-2" *ngIf="tableType != 'list'">
                                <button (click)="tableType = 'list'; showItems()" type="button" class="btn btn-block btn-success">{{ 'user.table_view' | transloco }}</button>
                            </div>
                            <div class="col-6 col-md-2" *ngIf="tableType != 'image'">
                                <button (click)="tableType = 'image'; showItems()" type="button" class="btn btn-block btn-success">{{ 'user.image_view' | transloco }}</button>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-6 col-md-2">
                                <button (click)="predicate.mode = 'お気に入り'; showItems()" type="button" class="btn btn-block btn-primary">{{ 'user.favorites' | transloco }}</button>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="view == 'custom'">
                        <div class="form-group row">
                            <label class="col-md-2 form-control-label">{{ 'user.item_id' | transloco }}</label>
                            <div class="col-md-2">
                                <input type="number" [(ngModel)]="predicate.id" class="form-control" [placeholder]="'user.item_id' | transloco">
                            </div>
                            <label class="col-md-2 form-control-label">{{ 'user.event_date' | transloco }}</label>
                            <div class="col-md-2">
                                <wj-input-date style="width:100%;" style="width:100%;" [(value)]="predicate.eventDate" [format]="'yyyy/MM/dd'" [isRequired]="false" [placeholder]="'user.event_date' | transloco"></wj-input-date>
                            </div>
                            <label class="col-md-2 form-control-label">{{ 'user.lane' | transloco }}</label>
                            <div class="col-md-2">
                                <select class="form-control" [(ngModel)]="predicate.lane">
                                    <option value="">-</option>
                                    <option *ngFor="let item of optionLane" [value]="item.value">{{ item.value }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-2 form-control-label">{{ 'user.item_category' | transloco }}</label>
                            <div class="col-md-2">
                                <select class="form-control" [(ngModel)]="predicate.category">
                                    <option value="">-</option>
                                    <option *ngFor="let item of optionCategory" [value]="item.value">{{ item.value }}</option>
                                </select>
                            </div>
                            <label class="col-md-2 form-control-label">{{ 'user.auction_result' | transloco }}</label>
                            <div class="col-md-2">
                                <select class="form-control" [(ngModel)]="predicate.auctionResult">
                                    <option value="">-</option>
                                    <option *ngFor="let item of optionAuctionResult" [value]="item.value">{{ item.value }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-2 form-control-label">{{ 'user.item_name' | transloco }}</label>
                            <div class="col-md-2">
                                <input type="text" [(ngModel)]="predicate.name" class="form-control" [placeholder]="'user.item_name' | transloco">
                            </div>
                            <label class="col-md-2 form-control-label">{{ 'user.item_description' | transloco }}</label>
                            <div class="col-md-2">
                                <input type="text" [(ngModel)]="predicate.description" class="form-control" [placeholder]="'user.item_description' | transloco">
                            </div>
                            <div class="col-6 col-md-2">
                                <button (click)="showItems()" class="btn btn-primary btn-block">{{ 'common.search' | transloco }}</button>
                            </div>
                            <div class="col-6 col-md-2">
                                <button (click)="resetPredicate()" class="btn btn-success btn-block">{{ 'user.reset' | transloco }}</button>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="tableType=='image'">
                        <div class="row" style="margin-top: 10px;">
                            <div class="mx-auto">
                                <pagination #paginationHeader [boundaryLinks]="true" [directionLinks]="true" [totalItems]="items.totalCount" [itemsPerPage]="items.pageSize" [firstText]="'user.page_first' | transloco" [lastText]="'user.page_last' | transloco" [previousText]="'user.page_previous' | transloco" [nextText]="'user.page_next' | transloco" (pageChanged)="pageChanged($event)" (numPages)="numPages($event)"></pagination>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4" *ngFor="let item of items.items">
                                <div class="card">
                                    <div class="card-header">
                                        <ng-container *ngIf="!isFollowers(item)">
                                            <i class="fa fa-star-o" (click)="addFollowers(item)"></i>
                                        </ng-container>
                                        <ng-container *ngIf="isFollowers(item)">
                                            <i style="color: red" class="fa fa-star" (click)="removeFollowers(item)"></i>
                                        </ng-container>
                                    </div>
                                    <div class="card-body" (click)="showItem(item)">
                                        <div class="row">
                                            <div class="col-12">
                                                <img *ngIf="item.images && item.images.length > 0" [src]="getImageSrc(item,item.images[0])" style="max-width: 350px; width: 100%;"/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-2 col-md-2 form-control-label" style="font-size: 62.5%;">{{ 'user.item_id' | transloco }}</label>
                                            <div class="col-4 col-md-4" style="font-weight: 700;">
                                                {{item.id}}
                                            </div>
                                            <label class="col-2 col-md-2 form-control-label" style="font-size: 62.5%;">{{ 'user.item_category' | transloco }}</label>
                                            <div class="col-4 col-md-4" style="font-weight: 700;">
                                                {{item.category}}
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-6 col-md-2 form-control-label" style="font-size: 62.5%;">{{ 'user.item_name' | transloco }}</label>
                                            <div class="col-6 col-md-10" style="font-weight: 700;">
                                                {{item.name}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" style="margin-top: 10px;">
                            <div class="mx-auto">
                                <pagination #paginationFooter [boundaryLinks]="true" [directionLinks]="true" [totalItems]="items.totalCount" [itemsPerPage]="items.pageSize" [firstText]="'user.page_first' | transloco" [lastText]="'user.page_last' | transloco" [previousText]="'user.page_previous' | transloco" [nextText]="'user.page_next' | transloco" (pageChanged)="pageChanged($event)" (numPages)="numPages($event)"></pagination>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="tableType=='list'">
                        <div class="row">
                            <div class="col-sm-12">
                                <wj-multi-row *ngIf="screenWidth >= 768" #itemGrid [isReadOnly]="true" [selectionMode]="'Row'" style="height:500px" [itemsSource]="items" (dblclick)="showItem(item)">
                                    <wj-multi-row-cell-group>
                                        <wj-multi-row-cell binding='id' [header]="'user.item_id' | transloco" [dataType]="'Number'" [width]="80">
                                        </wj-multi-row-cell>
                                    </wj-multi-row-cell-group>
                                    <wj-multi-row-cell-group>
                                        <wj-multi-row-cell binding='auction.eventDate' [header]="'user.event_date' | transloco" [dataType]="'Date'" [format]="'yyyy/MM/dd'" [width]="100">
                                        </wj-multi-row-cell>
                                    </wj-multi-row-cell-group>
                                    <wj-multi-row-cell-group>
                                        <wj-multi-row-cell binding='auction.place' [header]="'user.venue' | transloco" [width]="80">
                                        </wj-multi-row-cell>
                                    </wj-multi-row-cell-group>
                                    <wj-multi-row-cell-group>
                                        <wj-multi-row-cell binding='auction.lane' [header]="'user.lane' | transloco" [width]="100">
                                        </wj-multi-row-cell>
                                    </wj-multi-row-cell-group>
                                    <wj-multi-row-cell-group>
                                        <wj-multi-row-cell binding='images' [header]="'user.image' | transloco" [width]="100">
                                            <ng-template wjMultiRowCellTemplate [cellType]="'Cell'" let-cell="cell">
                                                <img *ngIf="cell.item.images && cell.item.images.length > 0" [src]="getImageSrc(cell.item,cell.item.images[0])" height="50"/>
                                            </ng-template>
                                        </wj-multi-row-cell>
                                    </wj-multi-row-cell-group>
                                    <wj-multi-row-cell-group>
                                        <wj-multi-row-cell binding='category' [header]="'user.item_category' | transloco" [width]="100">
                                        </wj-multi-row-cell>
                                    </wj-multi-row-cell-group>
                                    <wj-multi-row-cell-group>
                                        <wj-multi-row-cell binding='auctionResult' [header]="'user.auction_result' | transloco" [width]="100">
                                        </wj-multi-row-cell>
                                    </wj-multi-row-cell-group>
                                    <wj-multi-row-cell-group>
                                        <wj-multi-row-cell binding='name' [header]="'user.item_name' | transloco" [width]="150">
                                        </wj-multi-row-cell>
                                    </wj-multi-row-cell-group>
                                    <wj-multi-row-cell-group>
                                        <wj-multi-row-cell binding='description' [header]="'user.item_description' | transloco" [width]="200">
                                        </wj-multi-row-cell>
                                    </wj-multi-row-cell-group>
                                    <wj-multi-row-cell-group>
                                        <wj-multi-row-cell binding='quantity' [header]="'user.quantity' | transloco" [dataType]="'Number'" [width]="80">
                                        </wj-multi-row-cell>
                                    </wj-multi-row-cell-group>
                                    <wj-multi-row-cell-group>
                                        <wj-multi-row-cell binding='unit' [header]="'user.unit' | transloco" [width]="80">
                                        </wj-multi-row-cell>
                                    </wj-multi-row-cell-group>
                                    <wj-multi-row-cell-group>
                                        <wj-multi-row-cell binding='minimumPrice' [header]="'user.minimum_price' | transloco" [dataType]="'Number'" [width]="80">
                                        </wj-multi-row-cell>
                                    </wj-multi-row-cell-group>
                                    <wj-multi-row-cell-group>
                                        <wj-multi-row-cell binding='startPrice' [header]="'user.start_price' | transloco" [dataType]="'Number'" [width]="80">
                                        </wj-multi-row-cell>
                                    </wj-multi-row-cell-group>
                                </wj-multi-row>
                                <wj-multi-row *ngIf="screenWidth < 768" #itemGrid [isReadOnly]="true" [selectionMode]="'Row'" style="height:500px" [itemsSource]="items">
                                    <wj-multi-row-cell-group>
                                        <wj-multi-row-cell binding='id' [header]="'user.item_id' | transloco" [dataType]="'Number'" [width]="100">
                                        </wj-multi-row-cell>
                                        <wj-multi-row-cell binding='images' [header]="'user.image' | transloco" [width]="100">
                                            <ng-template wjMultiRowCellTemplate [cellType]="'Cell'" let-cell="cell">
                                                <img *ngIf="cell.item.images && cell.item.images.length > 0" [src]="getImageSrc(cell.item,cell.item.images[0])" height="50"/>
                                            </ng-template>
                                        </wj-multi-row-cell>
                                    </wj-multi-row-cell-group>
                                    <wj-multi-row-cell-group>
                                        <wj-multi-row-cell binding='category' [header]="'user.item_category' | transloco" [width]="100">
                                        </wj-multi-row-cell>
                                        <wj-multi-row-cell binding='auctionResult' [header]="'user.auction_result' | transloco" [width]="100">
                                        </wj-multi-row-cell>
                                    </wj-multi-row-cell-group>
                                    <wj-multi-row-cell-group>
                                        <wj-multi-row-cell binding='name' [header]="'user.item_name' | transloco" [width]="150">
                                        </wj-multi-row-cell>
                                        <wj-multi-row-cell binding='description' [header]="'user.item_description' | transloco" [width]="150" [rowspan]="2">
                                        </wj-multi-row-cell>
                                    </wj-multi-row-cell-group>
                                    <wj-multi-row-cell-group>
                                        <wj-multi-row-cell binding='quantity' [header]="'user.quantity' | transloco" [dataType]="'Number'" [width]="80">
                                        </wj-multi-row-cell>
                                        <wj-multi-row-cell binding='minimumPrice' [header]="'user.minimum_price' | transloco" [dataType]="'Number'" [width]="80">
                                        </wj-multi-row-cell>
                                        <wj-multi-row-cell binding='startPrice' [header]="'user.start_price' | transloco" [dataType]="'Number'" [width]="80">
                                        </wj-multi-row-cell>
                                    </wj-multi-row-cell-group>
                                    <wj-multi-row-cell-group>
                                        <wj-multi-row-cell binding='auction.eventDate' [header]="'user.event_date' | transloco" [dataType]="'Date'" [format]="'yyyy/MM/dd'" [width]="100">
                                        </wj-multi-row-cell>
                                        <wj-multi-row-cell binding='auction.place' [header]="'user.venue' | transloco" [width]="100">
                                        </wj-multi-row-cell>
                                        <wj-multi-row-cell binding='auction.lane' [header]="'user.lane' | transloco" [width]="100">
                                        </wj-multi-row-cell>
                                    </wj-multi-row-cell-group>
                                </wj-multi-row>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <ng-container *ngIf="tableType=='list'">
        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-footer">
                        <div style="float:left; min-width: 150px;">
                            <wj-menu [(value)]="items.pageSize" [header]="'user.page_size' | transloco">
                                <wj-menu-item [value]="20">20</wj-menu-item>
                                <wj-menu-item [value]="100">100</wj-menu-item>
                                <wj-menu-item [value]="500">500</wj-menu-item>
                                <wj-menu-item [value]="1000">1000</wj-menu-item>
                            </wj-menu>
                        </div>
                        <div style="float:left; min-width: 150px;">
                            <wj-collection-view-navigator [cv]="items"></wj-collection-view-navigator>
                        </div>
                        <div style="float:left; min-width: 150px;">
                            <wj-collection-view-pager [cv]="items"></wj-collection-view-pager>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>

